export const SETTINGS_TAB_KEY = 'settings';
export const MENTORS_TAB_KEY = 'mentors';
export const CONNECTIONS_TAB_KEY = 'connections';

export const MENTORSHIP_BASE_PATH = '/mentorship';
export const SETTINGS_TAB_PATH = `${MENTORSHIP_BASE_PATH}/settings`;
export const MENTORS_TAB_PATH = `${MENTORSHIP_BASE_PATH}/mentors`;
export const CONNECTIONS_TAB_PATH = `${MENTORSHIP_BASE_PATH}/connections`;

export const FORMS_MENTORSHIP_ID = 13;

export const MESSAGES_MODAL_PARAM = 'message_connection_id';
export const FEEDBACK_MODAL_PARAM = 'feedback_connection_id';
export const MENTOR_MODAL_PARAM = 'mentor_profile_id';
export const TOUCHPOINTS = {
  JOIN_MENTORSHIP_BUTTON_CLICK: 'mentorship-clicked-on-join-mentorship-program',
};

export const TABS_CONFIG = [
  {
    path: MENTORS_TAB_PATH,
    title: 'Mentors',
    key: MENTORS_TAB_KEY,
  },
  {
    path: CONNECTIONS_TAB_PATH,
    title: 'Connections',
    key: CONNECTIONS_TAB_KEY,
  },
  {
    path: SETTINGS_TAB_PATH,
    title: 'Settings',
    key: SETTINGS_TAB_KEY,
  },
];

export const ROUTES_MAPPING = [
  {
    key: SETTINGS_TAB_KEY,
    value: SETTINGS_TAB_PATH,
  },
  {
    key: MENTORS_TAB_KEY,
    value: MENTORS_TAB_PATH,
  },
  {
    key: CONNECTIONS_TAB_KEY,
    value: CONNECTIONS_TAB_PATH,
  },
];

export const MENTORSHIP_STATUS = {
  sent: {
    bgColor: '#FFF7E6',
    color: '#D46B08',
  },
  connected: {
    bgColor: '#D9F7BE',
    color: '#237804',
  },
  completed: {
    bgColor: '#E6F7FF',
    color: '#0050B3',
  },
};
